/*eslint-disable */

import {bus} from '../../main';
import headerAfterLogin from '../lymphomap-header/index';
import headerBeforeLogin from '../headerBeforeLogin/index';
import lbilHeaderAfterLogin from '../lbil/lbil-header/lbilHeader.vue';
import {
  mapGetters
} from 'vuex';

export default {
  name: 'app_header',
  components: {
    'header-before-login': headerBeforeLogin,
    'header-after-login': headerAfterLogin,
    'lbil-header-after-login': lbilHeaderAfterLogin
  },
  props: [],
  data () {
    return {
      isLoggedIn: '',
      lbilHeader:''
    }
  },
  computed:{
    checkUserLogin() {
      return this.isLoggedIn = this.$store.getters.isAuthenticated
    }
  },

  mounted () {
    bus.$on('headerPlatformBus', (data) => {
      this.lbilHeader = data
      localStorage.setItem('platform', data)
    });
    this.lbilHeader = localStorage.getItem('platform')
  },
  methods: {

  },
  updated(){

  },
  created(){
  },
  watch: {
    checkUserLogin() {
      return this.$store.getters.isAuthenticated
    }
  }
}
